import { Alert, Box, Link, Stack, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { fCurrency } from "../../utils/formatNumber";

type RelatedLedger = { name: string; amount: number };

export default function RelatedLedgers({ ledgerName, refreshKey }: { ledgerName: string; refreshKey: string }) {
  const [ledgers, setLedgers] = useState<RelatedLedger[]>([]);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    setFailed(false);
    axios.get<RelatedLedger[]>("/proxy/api/fundstransfer/GetRelatedLedgers", { params: { ledgerName } })
      .then(({ data }) => { if (active) setLedgers(data); })
      .catch(() => { if (active) { setLedgers([]); setFailed(true); } });
    return () => { active = false; };
  }, [ledgerName, refreshKey]);
  if (failed) return <Alert severity="warning" sx={{ mb: 2 }}>Unable to load related ledgers.</Alert>;
  if (!ledgers.length) return null;
  const parent = ledgerName.replace(/-(recording|escrow\d+)$/i, "");
  const sorted = [...ledgers].sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }));
  return <Box sx={{ mb: 3 }}>
    <Typography variant="subtitle2" sx={{ mb: 1 }}>Related ledgers</Typography>
    <Stack direction="row" spacing={3} useFlexGap flexWrap="wrap">
      {sorted.map(ledger => {
        const isParent = ledger.name.toLowerCase() === parent.toLowerCase();
        const label = isParent ? "Order Ledger" : ledger.name.slice(parent.length + 1).replace(/^escrow/i, "Escrow ");
        const current = ledger.name.toLowerCase() === ledgerName.toLowerCase();
        return current
          ? <Typography key={ledger.name} variant="body2" fontWeight={600}>{label}: {fCurrency(ledger.amount)} (current)</Typography>
          : <Link key={ledger.name} href={`/ledger/${encodeURIComponent(ledger.name)}`}>{label}: {fCurrency(ledger.amount)}</Link>;
      })}
    </Stack>
  </Box>;
}
